import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import RichText from "@/components/feature/RichText";
import Button from "@/components/base/Button";
import CTASection from "@/components/feature/CTASection";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function Nosotros() {
  const { data, whatsappLink } = useSiteData();
  const t = useT();
  const etiqueta = t("nosotros.etiqueta");
  const valoresEtiqueta = t("nosotros.valores_etiqueta");
  const foto = t("nosotros.foto");
  const hero = data.pages.nosotros;
  const valores = data.contentBlocks.nosotros?.valores ?? [];

  return (
    <Layout>
      <PageHero
        titulo={hero.hero_titulo}
        descripcion={hero.hero_descripcion}
        imagen={hero.hero_imagen_url}
        alt={hero.hero_imagen_alt}
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
              <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                {t("nosotros.titulo")}
              </h2>
              <div className="text-foreground-600 leading-relaxed">
                <RichText text={hero.body_rich_text ?? ""} paragraphClassName="mt-3" />
              </div>
            </div>
            {foto && (
              <img
                src={foto}
                alt={t("nosotros.foto_alt")}
                className="rounded-lg w-full h-72 md:h-96 object-cover object-top"
              />
            )}
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-2xl">
            {valoresEtiqueta && <span className="text-sm font-semibold text-accent-600">{valoresEtiqueta}</span>}
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              {t("nosotros.valores_titulo")}
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {valores.map((v) => (
              <div key={v.id} className="rounded-lg bg-background-50 border border-background-200 p-7">
                <span className="w-12 h-12 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center">
                  <i className={`${v.icono} text-2xl`} />
                </span>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-900">{v.titulo}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="rounded-lg bg-primary-900 p-8 md:p-12 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50">{hero.cta_titulo}</h2>
            <p className="mt-3 text-background-200 max-w-xl mx-auto">{hero.cta_descripcion}</p>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Button href={whatsappLink()} variant="accent" icon="ri-whatsapp-line">
                {t("nosotros.boton_whatsapp")}
              </Button>
              <Button to="/contacto" className="bg-background-50 text-primary-800 hover:bg-background-100">
                {t("nosotros.boton_formulario")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </Layout>
  );
}
